import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasStringUserField } from '../editor-eligibility-rule/editor-eligibility-rule-has-string-user-field.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-string-user-field',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueHasStringUserFieldComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasStringUserField;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  stringUserFieldNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.stringUserFieldNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        stringUserFieldNames => {
          this.stringUserFieldNames = stringUserFieldNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.stringUserFieldNames === undefined) {
      return $localize `Not available`;
    }

    const userField = this.rule.getUserFieldName(this.stringUserFieldNames);
    return this.affirmative
      ? $localize `Candidate has the user field ${userField} with value ${this.rule.userFieldValuesString}`
      : $localize `Candidate has NOT the user field ${userField} with value ${this.rule.userFieldValuesString}`;
  }
}
